// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"ecee2fd4","329":"56628831","339":"904742ad","760":"d113b38b"}[chunkId] + ".chunk.js";
};